import API from "../Services/API";
import Model from "./Model";
import { toQueryString } from "../Services/helpers";
import State from "./State";

const useCustomers = (searchData, alwaysRefresh) => {
    let searchStr = toQueryString(searchData)

    return Model({
        alwaysRefresh,
        stateKey: ['customers', searchStr],
        fetchData: () => API.get('/customers?perPage=9999&include=jobs&'+searchStr),
        returnDataKey: 'customers',
        saveAdditionalData: (response) => {
            response.map((customer) => {
                State.putIfNotExists(['customer', customer.id], customer);
                return customer;
            });
        },
        defaultLoadingError: 'Failed to load customers.',
    });
}

const useCustomer = (customerId, alwaysRefresh) => {
    return Model({
        block: !customerId,
        alwaysRefresh,
        stateKey: ['customer', customerId],
        fetchData: () => API.get('/customers/'+customerId),
        returnDataKey: 'customer',
        registerAdditionalMethods: (opts) => {
            return {
                updateCustomer: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/customers/'+customerId, data),
                        'Customer updated',
                        true,
                    );
                },
                changeSecurity: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/customers/${customerId}/changeSecurity`),
                        'Customer PIN updated',
                        true,
                    );
                },
                scheduleJob: (jobId, data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/customers/${customerId}/jobs/${jobId}/schedule`, data),
                        'Job scheduled',
                        true,
                    );
                },
                markJobAsDone: (jobId, data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/customers/${customerId}/jobs/${jobId}/done`, data),
                        'Job marked as done',
                        true,
                    );
                },
                skipJob: (jobId, data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/customers/${customerId}/jobs/${jobId}/skip`, data),
                        'Job was skipped',
                        true,
                    );
                },
                updateJob: (jobId, data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/customers/${customerId}/jobs${jobId ? '/'+jobId : ''}`, data),
                        'Job was updated',
                        true,
                    );
                },
                updateJobItemisationAdjustment: (jobId, data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/customers/${customerId}/jobs/${jobId}/adjustment`, data),
                        'Job invoice adjustment was updated',
                        true,
                    );
                },
                addExternalPayment: (data) => {
                    data.customerId = customerId;
                    return opts.wrapUpdateCall(
                        () => API.post(`/payments/external`, data),
                        'External payment added',
                        true,
                    );
                },
                addLoyaltyCard: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/customers/${customerId}/loyaltyCards`, data),
                        'Loyalty card added',
                        true,
                    );
                },
                cancelLoyaltyCard: (id) => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/customers/${customerId}/loyaltyCards/${id}`),
                        'Loyalty card cancelled',
                        true,
                    );
                },
                editBalance: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/customers/${customerId}/${data.action}`, data),
                        'Balance was updated',
                        true,
                    );
                },
                chargePaymentMethod: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post(`/customers/${customerId}/chargePaymentMethod`, data),
                        'Charge started - it may take a few minutes to appear show on the customer\'s account',
                        true,
                    );
                },
                deleteJob: (jobId) => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/customers/${customerId}/jobs/${jobId}`),
                        'Job was deleted',
                        true,
                    );
                },
                deleteInvoice: (invoiceId) => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/customers/${customerId}/invoices/${invoiceId}`),
                        'Invoice was deleted',
                        true,
                    );
                },
                deleteCustomer: () => {
                    return opts.wrapUpdateCall(
                        () => API.delete(`/customers/${customerId}`),
                        'Customer deleted',
                        true,
                    );
                },
            }
        },
        defaultLoadingError: 'Failed to load customer.',
    });
}

const useReport = (alwaysRefresh = false) => {
    return Model({
        stateKey: 'customer-report',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/customers/report`),
        returnDataKey: 'report',
    })
}

export {
    useCustomers,
    useCustomer,
    useReport,
};
